<template>
    <div class=inline-video :class="{ playing : isPlaying, expanded : expanded }">

        <video
            :src="video"
            :placeholder="image || ''"
            @durationchange="durationChange"
            @timeupdate="timeUpdate"
            playsinline
            loop
            ref="video"
        >
            <track v-if="subtitles" label="English" kind=subtitles srclang="en" :src="subtitles" default>
        </video>

        <div class=video-controls v-if="showControls">
            <button class=play @click="toggle"></button>
            <button class=expand @click="toggleExpanded"></button>
        </div>

        <div ref="progress" class=progress @click="clickProgress">
            <div class=elapsed :style="{ width : ( videoProgress ) + '%' }"></div>
            <div class=current :style="{ left : ( videoProgress ) + '%' }">
                <div class=time>{{ getPrettyTime(seek) }}</div>
            </div>
            <div class=total-time>{{ getPrettyTime(duration) }}</div>
        </div>

        <span class=close @click="expanded = false"></span>

    </div>
</template>
<script>
export default {
    name : 'InlineVideo',
    props : {
        video        : String   ,
        image        : String   ,
        subtitles    : String   ,
        showControls : Boolean  ,
    },
    data() {
        return {
            isPlaying      : false ,
            videoReady     : false ,
            expanded       : false ,
            seek           : 0,
            duration       : 0,
            videoProgress  : 0,
        }
    },
    methods : {
        play() {
            this.$refs.video.play();
            this.isPlaying = true;
        },
        pause() {
            this.$refs.video.pause();
            this.isPlaying = false;
        },
        toggleExpanded() {
            this.expanded = !this.expanded;
        },
        toggle() {
            if( this.$refs.video.paused ) {
                this.play();
            }
            else {
                this.pause();
            }

        },
        click() {
            this.toggle();
        },
        durationChange() {
            this.videoReady = true;
            this.duration = this.$refs.video.duration;
        },
        timeUpdate() {
            this.seek = this.$refs.video.currentTime;
            this.videoProgress = this.$refs.video.currentTime / this.$refs.video.duration * 100;
        },
        getPrettyTime( seconds ) {
            seconds = Number(seconds);
            let h = Math.floor(seconds / 3600);
            let m = Math.floor(seconds % 3600 / 60);
            let s = Math.floor(seconds % 3600 % 60);

            let timeString = '';

            if( h ) {
                timeString += h + ':';
                timeString += m.toString().padStart(2,'0') + ':';
            }
            else {
                timeString += m.toString() + ':';
            }


            timeString += s.toString().padStart(2,'0');

            return timeString;
        },
        clickProgress(e) {
            let progress = this.$refs.progress;
            let gutter = 90;
            let clickPos = (e.pageX  - (progress.offsetLeft + progress.offsetParent.offsetLeft + gutter ) ) / progress.offsetWidth;

            this.setProgress( clickPos );
        },
        setProgress( progress ) {
            this.$refs.video.currentTime = this.$refs.video.duration * progress;
        },
    },

}
</script>